module.exports = __webpack_public_path__ + "static/media/dataDownload.6ed8c8f7.md";